import { createSlice } from '@reduxjs/toolkit';
// import type { PayloadAction } from '@reduxjs/toolkit';

export interface DiapositivaState {
    pagina: number
    contenido: string
}

export interface SeccionDiapositivaState {
    cid: string
    mid: string
    bid: string
    sid: string
    autor: string,
    diapositivas: Array<DiapositivaState>
}

export interface SeccionDiapositivasState {
    diapositivas: Array<SeccionDiapositivaState>
    isLoading: boolean
}


const initialState: SeccionDiapositivasState = {
    diapositivas: [{cid: '', mid: '', bid: '', sid: '', autor: '', diapositivas: [{ pagina: 0, contenido: ''}]}],
    isLoading: false

}

export const diapositivaSlice = createSlice({
    name: 'seccion-diapositivas',
    initialState,
    reducers: {
        setSeccionDiapositivas: (state, action) => {
            state.diapositivas = action.payload
        },
        startLoadingSeccionDiapositiva: (state) => {
            state.isLoading = true;
        },
        endLoadingSeccionDiapositiva: (state) => {
            state.isLoading = false;
        },
    },
})

// Action creators are generated for each case reducer function
export const { 
    setSeccionDiapositivas, 
    startLoadingSeccionDiapositiva, 
    endLoadingSeccionDiapositiva 
} = diapositivaSlice.actions

